import React from 'react';
import { NavLink as Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';

export const Footer = () => {

    return (
        <footer>
            <div className='container'>
                <div className='content sections'>
                    <div>
                        <Link to='/' exact={ true } onClick={() => scroll.scrollToTop()} className='icon__mp' >
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                        </Link>
                    </div>
                    <div className='list_group'>
                        <div className='list'>
                            <a href='https://minzdrav.gov.ru/' target="_blank">Министерство здравоохранения</a>
                            <a href='https://www.zdrav-novgorod.ru/' target="_blank">Министерство здравоохранения Нижегородской области</a>
                            <Link to='/help' exact={ true } onClick={() => scroll.scrollToTop()}>Помощь</Link>
                            <Link to='/terms' exact={ true } onClick={() => scroll.scrollToTop()}>Условия использования</Link>
                        </div>
                        <div className='list'>
                            <Link to='/about' exact={ true } onClick={() => scroll.scrollToTop()}>О проекте «MED-NN»</Link>
                            <Link to='/about' exact={ true } onClick={() => scroll.scrollToTop()}>Контакты</Link>
                            <a href='https://rus2.ru/' target="_blank">О разработчике</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

